import { AuthService } from "@service/auth.service";

const authService = AuthService.instance;

const prepareAuthHeaders = async (headers: Headers): Promise<Headers> => {
  const accessToken = await authService.getAccessToken();
  headers.set("Authorization", accessToken);
  return headers;
};

export default prepareAuthHeaders;
